import { FC, useContext } from "react";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import TopCountiesTable from "../components/TopCountiesTable";


const TopCountiesByGapExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Top 10 Counties by Gap Count";

  return (
    <div className="ecd-export__wrapper">
      <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
      <TopCountiesTable tableData={wizardContext.topCountiesByGapData} />
    </div>
  );
}

export default TopCountiesByGapExport;